import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { useTranslation } from "react-i18next";
import { z } from "zod";

const tableName = "g4_positions";

const filterG4PositionsSchema = z.object({
  strategy_from_id_equals: z.string().optional(),
  strategy_to_id_equals: z.string().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterG4PositionsSchema = z.infer<typeof filterG4PositionsSchema>;

export function FilterG4Positions() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: "strategy_from_id_equals",
      label: t(`${tableName}.searchbox.strategy_from_id_equals`, {
        defaultValue: "Stratégie source (id)",
      }),
      type: "input",
    },
    {
      name: "strategy_to_id_equals",
      label: t(`${tableName}.searchbox.strategy_to_id_equals`, {
        defaultValue: "Stratégie cible (id)",
      }),
      type: "input",
    },
    {
      name: "date",
      type: "dateRange",
      label: "Date",
      from: { name: "date_from" },
      to: { name: "date_to" },
      copy_from_to_when_to_empty: true,
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      columns={2}
      client="g4"
      schema={filterG4PositionsSchema}
      tableName="g4_positions"
      fields={fields}
    />
  );
}
